// const PREFIX = '/pharo-gsoc';
const PREFIX = '';

export const LANDING = PREFIX + '/';
export const IDEAS = PREFIX + '/ideas';
export const MENTORS = PREFIX + '/mentors';
export const CALL_FOR_STUDENTS = PREFIX + '/call-for-students';
